module.exports = __webpack_public_path__ + "static/media/miku-full.4d17717b.png";